/*
 * @Author: liyxt
 * @Date: 2020-05-06 14:00:41
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:55:18
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginPagination from 'bee-pagination';
require('bee-pagination/build/Pagination.css');
import hotkeys from './hotkeys';

require('./index.less');

// @hotkeys 和 @hetkeys()是不一样的
@hotkeys(true, { prevPage: 'ctrl+left', nextPage: 'ctrl+right' })
 class Pagination extends Component {
	render() {
		let { gap = true, className, ...others } = this.props;
		// 共享服务>作业平台>我的作业>我的作业 会有些问题 所以className采用覆盖法
		return <OriginPagination ref={(obj) => (this.pagination = obj)} {...others} className={`${className || 'PaginationStyle' } nc-pagination`} />;
	}
}
export default Pagination;
